import { Mutation } from "../types";

export default {
  [Mutation.SET_RESERVATION_INFO](state: any, payload: any) {
    state.reservationInfo = payload;
  },
};
